import { EntityId } from '@reduxjs/toolkit';
import { affacturageTypeEntityAdapter } from './affacturage-type.slice';
import { RootState } from '../../../_config/redux';

const affacturageSelector = affacturageTypeEntityAdapter.getSelectors<RootState>((state) => state.affacturageType);

export const selectaffacturageTypeById = (id: EntityId) => (state: RootState) => affacturageSelector.selectById(state, id);

export const selectAllaffacturageTypes = (state: RootState) => affacturageSelector.selectAll(state);